var form = {},
		busy = false;

function submit($form) {
	if (busy == false) {

		var submitButton = document.querySelectorAll('.is-newsletters > form .el-fake-submit'), i;
		for (i = 0; i < submitButton.length; ++i) {
			submitButton[i].style.display = "none";
		}

		// display none on el-field input and h4.serif
		var elField = document.querySelectorAll('.is-newsletters form .el-field'), i;
		for (i = 0; i < elField.length; ++i) {
			elField[i].style.display = "none";
		}
		var serif = document.querySelectorAll('.is-newsletters form h4.serif'), i;
		for (i = 0; i < serif.length; ++i) {
			serif[i].style.display = "none";
		}
		message( $form.find('.el-message'), { 'success': true, 'message': customData.translations.sidebarFormSuccess } );

		busy = true;
		var form_data = $form.serialize();
		let redirect_param = 'redirect';
		var redirect = '';
		var has_visitorkey = false;
		if ( form_data.indexOf( redirect_param ) > -1 ) {
			var parseString = form_data.split('&' + redirect_param + '=');
			var redirectString = parseString[1].split('&');
			redirect = redirectString[0];
		}
		let timeout = 0;
		var form_action = customData.ajaxURL;
		// $form.find('.el-message').removeClass('is-active');
		if ( -1 == form_data.indexOf('action=') ) {
			console.log('no action, using form action...');

			form_action = $form.attr('action');
			if ( 'undefined' != typeof parseString ) {
				form_data = parseString[0]; // without redirect
			}
			if ( 'undefined' == typeof form_action ) {
				console.log('no action');
				return false;
			}
			// visitor_key
			if ( form_data.indexOf('cd_visitorkey=') == -1 ) {
				var cd_visitorkey = 'cuvid';
				var get_cookies = "; " + decodeURIComponent( document.cookie );
				var parts = get_cookies.split("; " + cd_visitorkey + "=");
				if ( parts.length == 2 ) {
					has_visitorkey = true;
					cd_visitorkey = parts.pop().split(";").shift();
					form_data += '&cd_visitorkey=' + cd_visitorkey;
				}
				if ( customData.debug_on ) {
					console.log( get_cookies );
					console.log( form_data );
				}
			}
		}

		var xhr = $.ajax({
			method: 'POST',
			url: form_action,
			data: form_data,
			async: true,
			cache: false,
			dataType: 'json',
			processData: false,
		}).done(function(data) {

			// console.log('data: ' + data);

			// if ( 'undefined' != typeof data && null != data ) {
			// 	message( $form.find('.el-message'), data );
				// if ( data.success == true && ( 'undefined' != typeof data.redirect && '' != data.redirect ) ) {
				// 	if ( 'undefined' != typeof data.timeout && ! isNaN( data.timeout ) ) {
				// 		timeout = parseInt( data.timeout );
				// 	}
				// 	setTimeout(function(){
				// 		if ( 'undefined' != typeof data.window && 'new' == data.window ) {
				// 			window.open( data.redirect );
				// 		} else {
				// 			window.location = data.redirect;
				// 		}
				// 	}, timeout );
				// }
			// }
		});
		// .complete(function(jqXHR, status) {
		// 	// busy = false;
		// 	// let content_type = xhr.getResponseHeader("Content-Type");

		// 	// console.log( 'jqXHR: ' + status );

		// 	if ( customData.debug_on ) {
		// 		// console.log( status );
		// 		if ( 'undefined' != typeof xhr ) {
		// 			// console.log( xhr.getResponseHeader("Content-Type") );
		// 		} else {
		// 			console.log('XHR undefined');
		// 		}
		// 		// console.log( 'DEBUG XHR:' );
		// 		// console.log( jqXHR );
		// 		// console.log( jqXHR.status );
		// 		// console.log( status );
		// 		// console.log( jqXHR.statusText  );
		// 		// console.log( jqXHR.responseText );
		// 	}

		// 	var submitButton = document.querySelectorAll('.is-newsletters > form .el-fake-submit'), i;
		// 	for (i = 0; i < submitButton.length; ++i) {
		// 		submitButton[i].style.display = "none";
		// 	}

		// 	// console.log('customData.ajaxURL: ' + customData.ajaxURL);

		// 	if ( customData.ajaxURL != form_action ) { // external action
		// 		var textStatus = 'error',
		// 			is_success = false;

		// 		if ( 0 == jqXHR.status ) { // is error
		// 			textStatus = customData.translations.sidebarFormFailed;
		// 		} else if ( 200 == jqXHR.status ) { // got feedback
		// 			if ( jqXHR.responseText.indexOf( customData.signup_error1 ) > -1
		// 			  || jqXHR.responseText.indexOf( customData.signup_error2 ) > -1 ) {
		// 				textStatus = customData.translations.sidebarFormFailed;
		// 			// } else if ( content_type.indexOf( 'text/plain;charset=US-ASCII' ) > -1 ) {
		// 			// 	textStatus = customData.translations.sidebarFormNotSent;
		// 			} else {
		// 				var $dataLayer = {
		// 					'event':'registrationComplete',
		// 					'referer': window.location.href
		// 				};
		// 				window.dataLayer = window.dataLayer || [];
		// 				window.dataLayer.push( $dataLayer );
		// 				if ( customData.debug_on ) {
		// 					console.log( $dataLayer );
		// 				}
		// 				is_success = true;
		// 				if ( '' != redirect ) {
		// 					timeout = 1000;
		// 					textStatus = customData.translations.sidebarFormSuccessRedirect;
		// 					setTimeout(function(){
		// 						window.open( decodeURIComponent( redirect ) );
		// 					}, timeout );
		// 				} else {
		// 					textStatus = customData.translations.sidebarFormSuccess;
		// 				}
		// 			}
		// 		}
		// 		message( $form.find('.el-message'), { 'success': is_success, 'message': textStatus} );
		// 	}
		// });
	}
}

function message(elem,data) {
	if (elem.length != '') {
		if (elem != '') {
			if ( 'undefined' != typeof data && null != data && data.success == true) {
				elem.removeClass('has-error');
			} else {
				elem.addClass('has-error');
			}
			elem.text(data.message);
			elem.addClass('is-active');
		} else {
			elem.removeClass('is-active');
		}
	}
}

form.init = function() {
	$('.block-sidebar-form').each(function(){
		if (!$(this).hasClass('is-tickets')) {
			let $form = $(this).find('form'),
			$button = $form.find('.el-fake-submit a');

			$button.click(function(e) {
				e.preventDefault();
				$button.hide();
				$form.submit();
			});

			$form.submit(function(e) {
				e.preventDefault();
				if ( $form.find('.error-check').length > 0 ) {
					var $count = $form.find('.error-check').length,
						$correct = 0;
					$form.find('.error-check').each(function(){
						var $val = $(this).find('input').val();
						if ( 'email' == $(this).find('input').attr('type') ) {
							var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
							if ( re.test( $val ) == true ) {
								$correct++;
							}
						} else {
							if ( $val.length > 0 ) {
								$correct++;
							}
						}
					});
					if ( $count == $correct ) {
						submit($form);
					} else {
						message( $form.find('.el-message'), { 'success': false, 'message': customData.translations.sidebarFormFailed } );
						$button.show();
					}
				} else {
					submit($form);
				}
			});
		}
	});
}

export { form };

